import { render } from "./RatingField.vue?vue&type=template&id=e6efbcae"
import script from "./RatingField.vue?vue&type=script&lang=js"
export * from "./RatingField.vue?vue&type=script&lang=js"
script.render = render

export default script